module.exports = __webpack_public_path__ + "static/icons/icon-heart--fill-b65a93e7e18d8518b718a7dcada7763a.svg";